// Brand glyphs for the hero marquee. Paths come straight from the
// `simple-icons` package (CC0) — these are the canonical official marks the
// brands publish, not anything we've drawn ourselves. Tree-shaken: each named
// import pulls just that one icon's metadata, not the whole 3000-icon catalog.
import {
  siGmail,
  siGooglecalendar,
  siHubspot,
  siLinear,
  siNotion,
  siTelegram,
} from "simple-icons";

type IconProps = { size?: number };

function makeIcon(path: string, title: string) {
  return function BrandGlyph({ size = 24 }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        role="img"
        aria-label={title}
      >
        <path d={path} />
      </svg>
    );
  };
}

export type BrandMark = {
  name: string;
  Icon: (p: IconProps) => React.ReactNode;
};

// Order picks brands users will recognize fastest first.
// (We support more integrations than we show here — the full list lives in the
// Integrations section.)
export const BRAND_MARKS: BrandMark[] = [
  { name: siTelegram.title, Icon: makeIcon(siTelegram.path, siTelegram.title) },
  { name: siHubspot.title, Icon: makeIcon(siHubspot.path, siHubspot.title) },
  { name: siNotion.title, Icon: makeIcon(siNotion.path, siNotion.title) },
  { name: siLinear.title, Icon: makeIcon(siLinear.path, siLinear.title) },
  {
    name: siGooglecalendar.title,
    Icon: makeIcon(siGooglecalendar.path, siGooglecalendar.title),
  },
  { name: siGmail.title, Icon: makeIcon(siGmail.path, siGmail.title) },
];
